export default __webpack_public_path__ + "static/media/maintenance.8cb31328.svg";